import syncApi from './syncApi';

export const getPageTemplates = () =>
  syncApi.get('/pages/templates').then((response) => response.data);

export const extractPageContent = (sourceUrl) =>
  syncApi
    .post('/pages/extract', { sourceUrl }, { timeout: 30000 })
    .then((response) => response.data);

export const generatePayloadPage = (payload) =>
  syncApi
    .post('/pages/generate', payload, { timeout: 180000 })
    .then((response) => response.data);

